import { _ as r } from "../internals/export.js";
import { t } from "../internals/to-object.js";
import { l as e } from "../internals/length-of-array-like.js";
import { a as n } from "../internals/array-set-length.js";
import { d as o } from "../internals/delete-property-or-throw.js";
import { d as a } from "../internals/does-not-exceed-safe-integer.js";
r({
  target: "Array",
  proto: !0,
  arity: 1,
  forced: 1 !== [].unshift(0) || !function () {
    try {
      Object.defineProperty([], "length", {
        writable: !1
      }).unshift();
    } catch (r) {
      return r instanceof TypeError;
    }
  }()
}, {
  unshift: function unshift(r) {
    var i = t(this),
      s = e(i),
      f = arguments.length;
    if (f) {
      a(s + f);
      for (var l = s; l--;) {
        var m = l + f;
        l in i ? i[m] = i[l] : o(i, m);
      }
      for (var p = 0; p < f; p++) i[p] = arguments[p];
    }
    return n(i, s + f);
  }
});